import { mockComponent } from 'bloko/common/setupMockComponents';

const { SuggestLayer } = jest.requireActual('bloko/blocks/suggest/index.js');
export { SuggestLayer };

export default mockComponent('Suggest', null, {
    withChildren: true,
});
